import eipImg from '../../../assets/storymap/eip.png';
import { useId, useState } from 'react';

const EnvironmentImpactCard = () => {
    const [isOpen, setIsOpen] = useState(false);
    const contentId = useId();

    return (
        <>
        <div className="bg-white">
            <div className="relative w-full h-[400px] overflow-hidden">
                <img
                    src={eipImg}
                    alt="environment work"
                    className="absolute inset-0 w-full h-full object-cover"
                />
                <div className='absolute top-0 left-0 flex'>
                    <p className="pl-20 bg-white/70 backdrop-blur-sm px-4 py-3 text-sm md:text-lg">
                        The Environmental Improvements Program (EIP) supports
                        community-led environmental projects on public land and spaces.
                    </p>
                </div>
            </div>
        </div>
        <div className={`${isOpen ? 'pb-8' : 'pb-0'} bg-white py-2 pl-20 pr-8 shadow-xl scroll-mt-24`}>
                <div className='flex justify-between'>
                    <h1 className="text-3xl font-extrabold text-port-blue md:text-4xl lg:text-5xl">
                        SKCPF Environment & Sustainability Impact
                    </h1>
                    <div className="hidden">
                        <button
                            type="button"
                            aria-expanded={isOpen}
                            aria-controls={contentId}
                            onClick={() => setIsOpen((v) => !v)}
                            className="focus:outline-none focus-visible:ring-2 focus-visible:ring-port-blue bg-white/70 backdrop-blur-sm"
                        >
                            <svg
                                className={`h-10 w-10 transition-transform hover:scale-110 ${isOpen ? 'rotate-180' : 'rotate-0'
                                    }`}
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 10.94l3.71-3.71a.75.75 0 1 1 1.06 1.06l-4.24 4.24a.75.75 0 0 1-1.06 0L5.21 8.29a.75.75 0 0 1 .02-1.08z"
                                    clipRule="evenodd"
                                />
                            </svg>
                            <span className="sr-only">{isOpen ? 'Collapse section' : 'Expand section'}</span>
                        </button>
                    </div>
                </div>
                <p className="mt-2 max-w-4xl text-sm md:text-lg pb-4">
                    The Environmental Improvements Program (EIP) supports
                        community-led environmental projects on public land and spaces.
                </p>
                <div className="pr-8" id={contentId} hidden={!isOpen}>
                </div>
            </div>
        </>
    )
}

export default EnvironmentImpactCard;